import { first } from 'lodash'
import { IUserRole, IUserStatus } from './user-interface'

export const userRoles: IUserRole[] = [
  {
    title: 'Member',
    useraccesslevel: 6,
  },
  {
    title: 'Admin',
    useraccesslevel: 7,
  },
]

export const userStatus: IUserStatus[] = [
  {
    title: 'Deactivated',
    activation: 0,
    clsColor: 'text-[#EF3826] bg-[#EF3826]  bg-opacity-20',
  },
  {
    title: 'Active',
    activation: 2,
    clsColor: 'text-primary bg-primary  bg-opacity-20',
  },
  {
    title: 'Invited',
    activation: 1,
    clsColor: 'text-[#FFA756] bg-[#FFA756]  bg-opacity-20',
  },
]

export function getUserRoleByUseraccesslevel(
  useraccesslevel: number
): IUserRole {
  return (
    userRoles.find((i) => i.useraccesslevel === useraccesslevel) ??
    first(userRoles)!
  )
}

export function getUserStatusByActivation(activation: number): IUserStatus {
  return (
    userStatus.find((i) => i.activation === activation) ?? first(userStatus)!
  )
}
